<template>
  <v-container fluid>
    <v-row>
      <v-col cols="12" xl="2" lg="2" md="2" sm="6">
        <v-autocomplete v-model="queryForm.section" :items="sections" label="标段"
          :menu-props="{ bottom: true, offsetY: true }" no-data-text="无" dense outlined clearable hide-details>
        </v-autocomplete>
      </v-col>
      <v-col cols="12" xl="4" lg="4" md="4" sm="6">
        <v-autocomplete v-model="queryForm.name" :items="slinenames" label="线路名称（可多选）"
          :menu-props="{ bottom: true, offsetY: true }" no-data-text="无" dense outlined clearable hide-details multiple
          chips small-chips deletable-chips>
        </v-autocomplete>
      </v-col>
      <v-col cols="12" xl="3" lg="3" md="3" sm="6">
        <a-space>
          <v-autocomplete v-model="queryForm.departure" :items="sdepartures" label="始发"
            :menu-props="{ bottom: true, offsetY: true }" no-data-text="无" dense outlined clearable hide-details>
          </v-autocomplete>→
          <v-autocomplete v-model="queryForm.destination" :items="sdestinations" label="到达"
            :menu-props="{ bottom: true, offsetY: true }" no-data-text="无" dense outlined clearable hide-details>
          </v-autocomplete>
        </a-space>
      </v-col>
      <v-col cols="12" xl="3" lg="3" md="3" sm="6">
        <a-space>
          <v-btn @click="getdata()" color="primary" tile>查询</v-btn>
          <v-btn @click="exportdata()" dark color="cyan" tile>导出</v-btn>
          <v-checkbox v-model="queryForm.empty_return" label="单程空返" dense hide-details></v-checkbox>
        </a-space>
      </v-col>
    </v-row>
    <div class="d-flex justify-space-between align-center">
      <a-tabs v-model="type" @change="getdata()">
        <a-tab-pane :key="0" tab="单程"></a-tab-pane>
        <a-tab-pane :key="1" tab="往返"></a-tab-pane>
        <a-tab-pane :key="2" tab="往返-单程收入x2"></a-tab-pane>
        <a-tab-pane :key="3" tab="线路测算"></a-tab-pane>
        <a-tab-pane :key="4" tab="线路测算(投标)"></a-tab-pane>
      </a-tabs>
      <a-button v-if="type === 3" type="primary" @click="showaddlinerevenue">新增线路测算</a-button>
    </div>
    <v-card tile class="pa-2">
      <a-table size="small" :columns="headers" :data-source="list" :pagination="false" :locale="{ emptyText: '暂无数据' }"
        :scroll="{ x: width, y: height }" :customRow="(record, index) => {
          let opts = {
            className: record.className,
          }
          return opts;
        }">
        <template slot="fixed_cost" slot-scope="text, record">
          <a-input v-if="record.fixed_cost_editable" v-model="record.fixed_cost"
            @blur="update(record._id, 'cprice', record.fixed_cost)" />
          <span v-else>{{ record.fixed_cost }}</span>
        </template>
        <template slot="oecost" slot-scope="text, record">
          {{ record.ocost || record.ecost }}
        </template>
        <template slot="rcost" slot-scope="text, record">
          {{ record.rcost }}
        </template>
        <template slot="cost" slot-scope="text, record">
          {{ record.cost }}
        </template>
        <template slot="profit" slot-scope="text, record">
          <span :class="{
            'success--text': record.profit > 0,
            'error--text': record.profit < 0,
          }">{{ record.profit }}</span>
        </template>
        <template slot="rate" slot-scope="text, record">
          <span :class="{
            'success--text': record.rate > 0,
            'error--text': record.rate < 0,
          }">{{ record.rate }}</span>
        </template>
        <template slot="action" slot-scope="text, record">
          <a href="javascript:;" style="font-size:12px;" @click="showeditlinerevenue(record)">编辑</a>
        </template>
      </a-table>
    </v-card>
    <!-- 线路测算 - 新增/编辑弹框 -->
    <a-modal :visible="linerevenuemodel" :title="linerevenuetitle" @ok="savelinerevenue"
      @cancel="linerevenuemodel = false" ok-text="提交" cancel-text="取消" :width="800" :mask-closable="false">
      <a-form-model ref="linerevenueformRef" :model="linerevenueform" :label-col="{ span: 6 }"
        :wrapper-col="{ span: 16 }" size="small">
        <a-row :gutter="16">
          <a-col :span="12">
            <a-form-model-item label="出发地">
              <a-input v-model="linerevenueform.departure" placeholder="请输入出发地"
                @input="(v) => change('departure', v)" />
            </a-form-model-item>
          </a-col>
          <a-col :span="12">
            <a-form-model-item label="目的地">
              <a-input v-model="linerevenueform.destination" placeholder="请输入目的地"
                @input="(v) => change('destination', v)" />
            </a-form-model-item>
          </a-col>
          <a-col :span="12">
            <a-form-model-item label="单程/往返">
              <a-select v-model="linerevenueform.transport_kind" :options="transport_kinds" placeholder="请选择"
                @change="(v) => change('transport_kind', v)">
              </a-select>
            </a-form-model-item>
          </a-col>
          <a-col :span="12">
            <a-form-model-item label="车型">
              <a-select v-model="linerevenueform.vehicle_type" :options="vehicle_types" placeholder="请选择"
                @change="(v) => change('vehicle_type', v)">
              </a-select>
            </a-form-model-item>
          </a-col>
          <a-col :span="12">
            <a-form-model-item label="里程(KM)">
              <a-input-number v-model="linerevenueform.km" placeholder="请输入里程" style="width:100%;" />
            </a-form-model-item>
          </a-col>
          <a-col :span="12">
            <a-form-model-item label="收入(元)">
              <a-input-number v-model="linerevenueform.income" placeholder="请输入收入" :min="0" :precision="2"
                style="width: 100%" />
            </a-form-model-item>
          </a-col>
          <a-col :span="12">
            <a-form-model-item label="是否高速">
              <a-switch v-model="linerevenueform.is_highway" />
            </a-form-model-item>
          </a-col>
          <a-col :span="12">
            <a-form-model-item v-if="linerevenueform.transport_kind === '单程'" label="是否空返">
              <a-switch v-model="linerevenueform.is_empty_return" />
            </a-form-model-item>
          </a-col>
          <a-col :span="24">
            <a-form-model-item label="备注" :label-col="{ span: 3 }" :wrapper-col="{ span: 20 }">
              <a-textarea v-model="linerevenueform.remark" placeholder="请输入备注" :rows="2" style="width:100%;" />
            </a-form-model-item>
          </a-col>
        </a-row>
      </a-form-model>
    </a-modal>
  </v-container>
</template>

<script>
import _ from "underscore";
import { mapState } from "vuex";
import ExcelJS from 'exceljs';
export default {
  name: "LineRevenue",
  data() {
    return {
      queryForm: {
        section: "",
        name: [],
        departure: "",
        destination: ""
      },
      activeKey: ['0'],
      type: 0,
      sections: [],
      linenames: [],
      departures: [],
      destinations: [],
      list: [],
      height: 800,
      transport_kinds: [
        { value: "单程", label: "单程" },
        { value: "往返", label: "往返" },
      ],
      postlines: [],
      postlinecontracts: [],
      vehicle_types: [],
      linerevenuemodel: false,
      linerevenuetitle: '',
      linerevenueform: {},
    };
  },
  computed: {
    ...mapState(["role", "username"]),
    width() {
      return _.reduce(this.headers, (a, b) => a + (b.width || 300), 0);
    },
    headers() {
      return [
        {
          title: "序号", dataIndex: "index", scopedSlots: { customRender: "index" }, width: 80, align: "center",
          customRender: (value, row, index) => {
            const obj = {
              children: value,
              attrs: {
                rowSpan: (this.type === 3 || this.type === 4) ? 1 : (row.rowSpan || 0),
              },
            };
            return obj;
          },
        },
        {
          title: "线路名称", dataIndex: "linename", scopedSlots: { customRender: "linename" }, width: 100, align: "center",
          customRender: (value, row, index) => {
            const obj = {
              children: value,
              attrs: {
                rowSpan: (this.type === 3 || this.type === 4) ? 1 : (row.rowSpan || 0),
              },
            };
            return obj;
          },
        },
        ...((this.type === 3 || this.type === 4) ? [
          {
            title: "单程/往返", dataIndex: "transport_kind", scopedSlots: { customRender: "transport_kind" }, width: 100, align: "center",
            // customRender: (value, row, index) => {
            //   const obj = {
            //     children: value,
            //     attrs: {
            //       rowSpan: row.rowSpan || 0,
            //     },
            //   };
            //   return obj;
            // },
          },
        ] : []),
        {
          title: "里程(KM)", dataIndex: "km", scopedSlots: { customRender: "km" }, width: 100, align: "center",
          customRender: (value, row, index) => {
            const obj = {
              children: value,
              attrs: {
                rowSpan: (this.type === 3 || this.type === 4) ? 1 : (row.rowSpan || 0),
              },
            };
            return obj;
          },
        },
        { title: "车型", dataIndex: "vehicle_type2", scopedSlots: { customRender: "vehicle_type2" }, width: 100, align: "center" },
        { title: "固定成本(元)", dataIndex: "fixed_cost", scopedSlots: { customRender: "fixed_cost" }, width: 100, align: "center" },
        { title: "油/电费(元)", dataIndex: "oecost", scopedSlots: { customRender: "oecost" }, width: 100, align: "center" },
        { title: "过路费(元)", dataIndex: "rcost", scopedSlots: { customRender: "rcost" }, width: 100, align: "center" },
        ...((this.type !== 1 && this.type !== 2) ? [
          { title: "成本(元)", dataIndex: "cost", scopedSlots: { customRender: "cost" }, width: 100, align: "center" },
          { title: "空返成本(元)", dataIndex: "cost0", scopedSlots: { customRender: "cost0" }, width: 100, align: "center" },
          { title: "总成本(元)", dataIndex: "tcost", scopedSlots: { customRender: "tcost" }, width: 100, align: "center" },
        ] : [
          { title: "成本(元)", dataIndex: "cost", scopedSlots: { customRender: "cost" }, width: 100, align: "center" },
        ]),
        { title: "收入(元)", dataIndex: "income", scopedSlots: { customRender: "income" }, width: 100, align: "center" },
        { title: "利润(元)", dataIndex: "profit", scopedSlots: { customRender: "profit" }, width: 100, align: "center" },
        { title: "利润率", dataIndex: "rate", scopedSlots: { customRender: "rate" }, width: 100, align: "center" },
        ...(this.type === 3 ? [
          { title: "编辑", dataIndex: "action", scopedSlots: { customRender: "action" }, width: 80, align: "center", fixed: "right" },
        ] : []),
      ];
    },
    slinenames() {
      if (this.queryForm.section) {
        return this.linenames.filter(n => n.section === this.queryForm.section);
      }
      return this.linenames;
    },
    sdepartures() {
      if (this.queryForm.section) {
        return this.departures.filter(n => n.section === this.queryForm.section);
      }
      return this.departures;
    },
    sdestinations() {
      if (this.queryForm.section) {
        return this.destinations.filter(n => n.section === this.queryForm.section);
      }
      return this.destinations;
    },
  },
  components: {},
  watch: {
  },
  mounted() {
    this.height = window.innerHeight - 50;
    window.onresize = (e) => {
      console.log("onresize", window.innerHeight);
      this.height = window.innerHeight - 50;
    };
    this.list = [];
  },
  activated() {
    this.getdata();
  },
  methods: {
    getdata() {
      this.$toast.loading({ message: "" });
      this.$api.doAPI("/linerevenue/list3", { ...this.queryForm, type: this.type })
        .then((res) => {
          this.$toast.clear();
          if (res.code === 0) {
            this.list = res.data.list || [];
            this.sections = res.data.sections || [];
            this.linenames = res.data.linenames || [];
            this.departures = res.data.departures || [];
            this.destinations = res.data.destinations || [];
          }
          else {
            this.$alert(res.msg);
          }
        })
        .catch((err) => {
          this.$toast.clear();
          console.error(err);
        });
    },
    async exportdata() {
      let rows = [];
      let name = '';
      if (this.type === 0) {//单程
        name = '（单程）';
        rows.push(
          [
            "线路名称",
            "里程(KM)",
            "车型",
            "固定成本(元)",
            "油/电费(元)",
            "过路费(元)",
            "成本(元)",
            "空返成本(元)",
            "总成本(元)",
            "收入(元)",
            "利润(元)",
            "利润率"
          ],
          ...this.list.map(n => [
            n.linename,
            +n.km,
            n.vehicle_type2,
            +n.fixed_cost,
            +n.ocost || +n.ecost,
            +n.rcost,
            +n.cost,
            +n.cost0,
            +n.tcost,
            +n.income,
            +n.profit,
            +n.rate,
          ]),
        )
      }
      else if (this.type === 1) {//往返
        name = '（往返）';
        rows.push(
          [
            "线路名称",
            "里程(KM)",
            "车型",
            "固定成本(元)",
            "油/电费(元)",
            "过路费(元)",
            "成本(元)",
            "收入(元)",
            "利润(元)",
            "利润率"
          ],
          ...this.list.map(n => [
            n.linename,
            +n.km,
            n.vehicle_type2,
            +n.fixed_cost,
            +n.ocost || +n.ecost,
            +n.rcost,
            +n.cost,
            +n.income,
            +n.profit,
            +n.rate,
          ]),
        )
      }
      else if (this.type === 2) {//往返-单程收入x2
        name = '（往返-单程收入x2）';
        rows.push(
          [
            "线路名称",
            "里程(KM)",
            "车型",
            "固定成本(元)",
            "油/电费(元)",
            "过路费(元)",
            "成本(元)",
            "收入(元)",
            "利润(元)",
            "利润率"
          ],
          ...this.list.map(n => [
            n.linename,
            +n.km,
            n.vehicle_type2,
            +n.fixed_cost,
            +n.ocost || +n.ecost,
            +n.rcost,
            +n.cost,
            +n.income,
            +n.profit,
            +n.rate,
          ]),
        )
      }
      else if (this.type === 3) {
        name = '（线路测算）';
        rows.push(
          [
            "线路名称",
            "单程/往返",
            "里程(KM)",
            "车型",
            "固定成本(元)",
            "油/电费(元)",
            "过路费(元)",
            "成本(元)",
            "空返成本(元)",
            "总成本(元)",
            "收入(元)",
            "利润(元)",
            "利润率"
          ],
          ...this.list.map(n => [
            n.linename,
            n.transport_kind,
            +n.km,
            n.vehicle_type2,
            +n.fixed_cost,
            +n.ocost || +n.ecost,
            +n.rcost,
            +n.cost,
            +n.cost0,
            +n.tcost,
            +n.income,
            +n.profit,
            +n.rate,
          ]),
        )
      }
      else if (this.type === 4) {
        name = '-线路测算（投标）';
        rows.push(
          [
            "线路名称",
            "单程/往返",
            "里程(KM)",
            "车型",
            "固定成本(元)",
            "油/电费(元)",
            "过路费(元)",
            "成本(元)",
            "空返成本(元)",
            "总成本(元)",
            "收入(元)",
            "利润(元)",
            "利润率"
          ],
          ...this.list.map(n => [
            n.linename,
            n.transport_kind,
            +n.km,
            n.vehicle_type2,
            +n.fixed_cost,
            +n.ocost || +n.ecost,
            +n.rcost,
            +n.cost,
            +n.cost0,
            +n.tcost,
            +n.income,
            +n.profit,
            +n.rate,
          ]),
        )
      }
      const workbook = new ExcelJS.Workbook();
      const worksheet = workbook.addWorksheet('Sheet1');
      worksheet.addRows(rows);
      const buffer = await workbook.xlsx.writeBuffer();
      this.$utils.downloadBlob([buffer], "application/octet-stream", `线路收益表${name}.xlsx`);
    },
    linerevenuetemplate() {
      return {
        _id: "",
        postlineid: "",
        departure: "",
        destination: "",
        transport_kind: undefined,
        km: "",
        vehicle_type: undefined,
        income: "",
        is_highway: false,
        is_empty_return: false,
        remark: "",
      };
    },
    showaddlinerevenue() {
      this.info().then(() => {
        this.linerevenueform = this.linerevenuetemplate();
        this.linerevenuetitle = "新增";
        this.linerevenuemodel = true;
      });
    },
    showeditlinerevenue(item) {
      this.info().then(() => {
        this.linerevenueform = _.pick(item, _.keys(this.linerevenuetemplate()));
        this.linerevenuetitle = "编辑";
        this.linerevenuemodel = true;
      });
    },
    change(key, value) {
      console.log('change', key, value);
      if (key === 'transport_kind') {
        let postline = this.postlines.find(n => n.departure === this.linerevenueform.departure && n.destination === this.linerevenueform.destination && n.transport_kind === value);
        console.log(postline);
        this.$set(this.linerevenueform, 'postlineid', postline?._id || '');
        this.$set(this.linerevenueform, 'km', '');
        this.$set(this.linerevenueform, 'vehicle_type', undefined);
        this.$set(this.linerevenueform, 'income', '');
      }
      else if (key === 'vehicle_type') {
        let postlinecontract = this.postlinecontracts.find(n => n.postlineid === this.linerevenueform.postlineid && n.vehicle_type === value);
        console.log(postlinecontract);
        this.$set(this.linerevenueform, 'km', postlinecontract?.km || '');
        this.$set(this.linerevenueform, 'income', postlinecontract?.price || '');
      }
      else {
        this.$set(this.linerevenueform, 'postlineid', '');
        this.$set(this.linerevenueform, 'km', '');
        this.$set(this.linerevenueform, 'vehicle_type', undefined);
        this.$set(this.linerevenueform, 'income', '');
      }
    },
    info() {
      this.$toast.loading({ message: "" });
      return this.$api.doAPI("/linerevenue/info").then((res) => {
        this.$toast.clear();
        if (res.code === 0) {
          this.postlines = res.data.postlines;
          this.postlinecontracts = res.data.postlinecontracts;
          this.vehicle_types = res.data.vehicle_types;
        }
        else {
          this.$alert(res.msg);
        }
      }).catch((err) => {
        this.$toast.clear();
        console.error(err);
      });
    },
    savelinerevenue() {
      this.$toast.loading({ message: "" });
      this.$api.doAPI("/linerevenue/save", { dataForm: this.linerevenueform })
        .then((res) => {
          this.$toast.clear();
          if (res.code === 0) {
            this.linerevenuemodel = false;
            this.getdata();
          }
          else {
            this.$alert(res.msg);
          }
        })
        .catch((err) => {
          this.$toast.clear();
          console.error(err);
        });
    },
    update(_id, key, value) {
      this.$toast.loading({ message: "" });
      this.$api.doAPI("/linerevenue/update", { _id, key, value }).then((res) => {
        this.$toast.clear();
        if (res.code === 0) {
          this.getdata();
        }
        else {
          this.$alert(res.msg);
        }
      }).catch((err) => {
        this.$toast.clear();
        console.error(err);
      });
    },
  },
};
</script>
<style lang="less" scoped>
/deep/ .row {
  margin-bottom: 0 !important;
}

/deep/ .row+.row {
  margin-top: 0;
}

/deep/ .col,
.col-12 {
  padding-bottom: 0 !important;
}

/deep/ .v-input--selection-controls {
  margin-top: 0;
  padding-top: 0;
}

/deep/ .v-data-table>.v-data-table__wrapper>table>tbody>tr>td {
  padding: 0 4px;
}

/deep/ .ant-table-fixed-header .ant-table-scroll .ant-table-header {
  padding-bottom: 4px;
}

/deep/ .ant-descriptions-title {
  margin-bottom: 0;
}

/deep/ .highlight {
  background-color: #e0edf9;
}

p {
  margin: 0;
}
</style>